<div class="fundo" role="dialog" aria-modal="true" aria-label="Encontrar disponibilidade">
  <div class="modal">
    <div class="modal-cab">
      <div class="cab-ico" aria-hidden="true">
        <svg class="i" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5M11 8v6M8 11h6" /></svg>
      </div>
      <div class="cab-txt">
        <b>Encontrar disponibilidade</b>
        <span>Vagas de todas as unidades da marca, a partir da data escolhida</span>
      </div>
      <button type="button" class="btn-ico fechar-modal" title="Fechar (Esc)" (click)="fechar.emit()">
        <svg class="i" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>

    <div class="corpo-disp">
      <!-- Filtros -->
      <aside class="filtros-disp" aria-label="Filtros da busca">
        <div class="campo">
          <span class="rot">Tipo</span>
          <div class="seg" role="group" aria-label="Tipo">
            <button type="button" [class.ativo]="tipo === 'CONSULTA'" (click)="escolherTipo('CONSULTA')">Consulta</button>
            <button type="button" [class.ativo]="tipo === 'EXAME'" (click)="escolherTipo('EXAME')">Exame</button>
            <button type="button" *ngIf="temOdonto" [class.ativo]="tipo === 'ODONTOLOGIA'" (click)="escolherTipo('ODONTOLOGIA')">Odontologia</button>
          </div>
        </div>

        <ng-container *ngIf="!ehExame">
          <div class="campo">
            <label for="dEsp">Especialidade</label>
            <select id="dEsp" [ngModel]="cdEspecialidade" (ngModelChange)="trocarEspecialidade($event)">
              <option [ngValue]="null" disabled>Selecione</option>
              <option *ngFor="let e of especialidades" [ngValue]="e.codigo">{{ e.descricao }}</option>
            </select>
          </div>
          <div class="campo">
            <label for="dMed">Médico</label>
            <select id="dMed" [ngModel]="cdMedico" (ngModelChange)="trocarMedico($event)" [disabled]="carregandoMedicos">
              <option [ngValue]="null">{{ carregandoMedicos ? 'Carregando...' : 'Todos' }}</option>
              <option *ngFor="let m of medicos" [ngValue]="m.cdMedico">{{ m.nmMedico }}</option>
            </select>
          </div>
        </ng-container>

        <ng-container *ngIf="ehExame">
          <div class="campo">
            <label for="dExame">Exame</label>
            <div class="exame-sel" *ngIf="exameEscolhido; else buscaExame">
              <div><b>{{ exameEscolhido.nome }}</b> <span class="sub2">{{ parceirosNaUf.length }} parceiro(s)</span></div>
              <button type="button" class="link" (click)="removerExame()">trocar</button>
            </div>
            <ng-template #buscaExame>
              <input
                id="dExame"
                type="search"
                autocomplete="off"
                placeholder="Nome do exame (mín. 3 letras)"
                [ngModel]="termoExame"
                (ngModelChange)="digitarExame($event)"
              />
              <p class="dica" *ngIf="buscandoExame">Buscando exames...</p>
              <p class="dica erro-txt" *ngIf="erroExame">{{ erroExame }}</p>
              <div class="lista-exames" *ngIf="examesEncontrados.length">
                <button type="button" *ngFor="let g of examesEncontrados" (click)="escolherExame(g)">
                  <span>{{ g.nome }} <span class="selo warn" *ngIf="g.semValor">sem valor</span></span>
                  <span class="sub2">{{ g.parceiros.length }} parceiro(s)</span>
                </button>
              </div>
              <p class="dica" *ngIf="!buscandoExame && termoExame.trim().length >= 3 && !examesEncontrados.length && !erroExame">Nenhum exame encontrado.</p>
            </ng-template>
          </div>
          <div class="campo" *ngIf="exameEscolhido">
            <label for="dMedEx">Médico</label>
            <select id="dMedEx" [ngModel]="cascata.cdMedico" (ngModelChange)="trocarMedicoExame($event)">
              <option [ngValue]="null">Todos</option>
              <option *ngFor="let m of cascata.medicos" [ngValue]="m.codigo">{{ m.descricao }}</option>
            </select>
          </div>
        </ng-container>

        <div class="campo">
          <label for="dUf">UF</label>
          <select id="dUf" [ngModel]="uf" (ngModelChange)="trocarUf($event)">
            <option [ngValue]="null">Todas</option>
            <option *ngFor="let u of ufs" [ngValue]="u.uf">{{ u.nome }}</option>
          </select>
        </div>

        <div class="campo">
          <label for="dUn">Unidade</label>
          <select *ngIf="!ehExame" id="dUn" [ngModel]="cdEstabelecimento" (ngModelChange)="trocarUnidade($event)">
            <option [ngValue]="null">Todas as unidades</option>
            <option *ngFor="let e of unidadesDaUf" [ngValue]="e.cdEstabelecimento">{{ e.nmEstabelecimento || e.sigla || e.cdEstabelecimento }}</option>
          </select>
          <select *ngIf="ehExame" id="dUn" [ngModel]="cascata.cdEstabelecimento" (ngModelChange)="trocarUnidadeExame($event)" [disabled]="!exameEscolhido">
            <option [ngValue]="null">Todas as unidades</option>
            <option *ngFor="let u of cascata.unidades" [ngValue]="u.codigo">{{ u.descricao }}</option>
          </select>
        </div>

        <div class="campo">
          <label for="dIni">A partir de</label>
          <input id="dIni" type="date" [ngModel]="dtInicio" (ngModelChange)="dtInicio = $event; limparResultado()" />
        </div>

        <div class="campo campo-pac">
          <span class="rot">Paciente <span class="opcional">(opcional)</span></span>
          <app-agenda-paciente
            [detalhes]="false"
            (pacienteMudou)="aoMudarPaciente($event)"
            (planoCarregado)="aoCarregarPlano($event)"
          ></app-agenda-paciente>
          <p class="dica" *ngIf="!paciente">Escolha o paciente para ver o preço dele em cada unidade.</p>
        </div>

        <label class="check" *ngIf="ehConsulta">
          <input type="checkbox" [ngModel]="soRetorno" (ngModelChange)="soRetorno = $event; limparResultado()" />
          Só com vaga de retorno
        </label>
        <p class="dica" *ngIf="ehConsulta && soRetorno && supervisor">Supervisão vê também os dias com retorno esgotado, marcados como cheio.</p>

        <div class="alerta bad" *ngIf="erroFiltros" role="alert"><div>{{ erroFiltros }}</div></div>

        <div class="linha-btn">
          <button type="button" class="btn btn-primario" style="flex: 1" [disabled]="!!falta || buscando" (click)="buscar()">
            <svg class="i sm" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
            {{ buscando ? 'Buscando...' : 'Buscar' }}
          </button>
          <button type="button" class="btn btn-contorno" (click)="limparFiltros()">Limpar</button>
        </div>
        <p class="dica" *ngIf="falta">{{ falta }}</p>
      </aside>

      <!-- Resultado -->
      <section class="resultado" aria-live="polite">
        <div class="alerta ok" *ngIf="sucesso" role="status">
          <svg class="i sm" viewBox="0 0 24 24"><path d="m5 12 5 5 9-10" /></svg>
          <div>{{ sucesso }}</div>
          <button type="button" class="btn-ico fechar" title="Fechar" (click)="sucesso = ''">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
          </button>
        </div>

        <div class="alerta warn" *ngIf="resultado?.limitado" role="status">
          <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
          <div><b>{{ MENSAGEM_LIMITADO }}</b> Os dias depois de {{ dataCurta(datas[datas.length - 1] || '') }} não foram carregados.</div>
        </div>

        <div class="alerta bad" *ngIf="erroBusca" role="alert">
          <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
          <div>{{ erroBusca }}</div>
        </div>

        <div class="vazio-disp" *ngIf="!buscou && !buscando && !erroBusca">
          <svg class="i" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
          Escolha os filtros e clique em Buscar.
        </div>
        <div class="vazio-disp" *ngIf="buscando">Buscando vagas...</div>

        <ng-container *ngIf="buscou && !buscando">
          <div class="nav-datas">
            <button type="button" class="btn-ico" title="Dias anteriores" [disabled]="!temAnterior || carregandoMais" (click)="abasAnteriores()">
              <svg class="i" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6" /></svg>
            </button>
            <div class="abas" role="tablist">
              <button
                type="button"
                role="tab"
                *ngFor="let d of abas"
                class="aba"
                [class.ativo]="dataSel === d"
                [attr.aria-selected]="dataSel === d"
                (click)="escolherData(d)"
              ><b>{{ dataCurta(d) }}</b><small>{{ rotuloAba(d) }}</small></button>
              <span class="dica" *ngIf="!abas.length">Nenhuma data com vaga.</span>
            </div>
            <button type="button" class="btn-ico" title="Próximos dias" [disabled]="!temSeguinte || carregandoMais" (click)="abasSeguintes()">
              <svg class="i" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6" /></svg>
            </button>
            <div class="cal-wrap">
              <button type="button" class="btn btn-contorno btn-sm" [class.ativo]="calendarioAberto" (click)="alternarCalendario()">
                <svg class="i sm" viewBox="0 0 24 24"><rect x="3" y="4.5" width="18" height="16" rx="2.5" /><path d="M3 9.5h18M8 2.5v4M16 2.5v4" /></svg>
                Calendário
              </button>
              <div class="cal-pop" *ngIf="calendarioAberto">
                <div class="cal-cab">
                  <button type="button" class="btn-ico" title="Mês anterior" [disabled]="!podeMesAnterior" (click)="mesCalAnterior()">
                    <svg class="i sm" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6" /></svg>
                  </button>
                  <b>{{ rotuloMesCal }}</b>
                  <button type="button" class="btn-ico" title="Mês seguinte" [disabled]="!podeMesSeguinte || carregandoMais" (click)="mesCalSeguinte()">
                    <svg class="i sm" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6" /></svg>
                  </button>
                </div>
                <div class="cal-grid">
                  <span class="dow" *ngFor="let d of diasSemana">{{ d }}</span>
                  <button
                    type="button"
                    *ngFor="let c of celulasCal"
                    class="cel"
                    [class.vazia]="!c.data"
                    [class.com-vaga]="c.comVaga"
                    [class.hoje]="c.hoje"
                    [class.sel]="c.data === dataSel"
                    [disabled]="!c.comVaga"
                    (click)="escolherDiaCalendario(c)"
                  >{{ c.data ? c.numero : '' }}</button>
                </div>
                <p class="dica" *ngIf="carregandoMais">Carregando vagas do mês...</p>
                <p class="dica" *ngIf="!carregandoMais && mesCalPendente">Parte do mês ainda não foi carregada.</p>
              </div>
            </div>
            <span class="dica" *ngIf="carregandoMais">Carregando mais dias...</span>
          </div>

          <div class="faixa-dica" *ngIf="paciente && semCotacao">Escolha a especialidade para ver os preços por unidade.</div>
          <div class="faixa-dica" *ngIf="!semCotacao && modoPreco === 'plano-carregando'">Consultando o plano do paciente...</div>
          <div class="faixa-dica preco-erro" *ngIf="!semCotacao && modoPreco === 'plano-erro'" role="alert">
            Não foi possível consultar o plano do paciente; os preços não foram mostrados.
          </div>

          <ng-container *ngIf="cards as lista">
            <div class="vazio-disp" *ngIf="!lista.length">Nenhuma vaga disponível nesta data.</div>

            <div class="card-un" *ngFor="let c of lista; trackBy: trackUnidade">
              <div class="un-cab">
                <b>{{ c.unidade.nmEstabelecimento || c.unidade.cdEstabelecimento }}</b>
                <span class="selo cinza" *ngIf="c.unidade.uf">{{ c.unidade.uf }}</span>
                <span class="sub2">{{ c.total }} vaga(s) no dia</span>
              </div>

              <ng-container *ngIf="mostraPreco && precoLinhaDa(c.unidade.cdEstabelecimento) as pp">
                <div class="preco-pac" [ngClass]="'pp-' + pp.estado" role="status">
                  <svg class="i sm" viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-8 8z" /><circle cx="7.5" cy="8.5" r="1.5" /></svg>
                  <ng-container [ngSwitch]="pp.estado">
                    <span *ngSwitchCase="'carregando'" class="sub2">Consultando o preço de {{ paciente?.nome }}...</span>
                    <span *ngSwitchCase="'erro'" class="preco-erro">{{ $any(pp).mensagem }}</span>
                    <span *ngSwitchCase="'sem'">
                      Preço para <b>{{ paciente?.nome }}</b>: <b class="valor">Sem preço</b> —
                      <span class="plano">{{ $any(pp).plano }} sem preço cadastrado nesta unidade</span>
                    </span>
                    <span *ngSwitchCase="'ok'">
                      Preço para <b>{{ paciente?.nome }}</b>: <b class="valor">{{ brl($any(pp).valor) }}</b> —
                      <span class="plano">{{ $any(pp).plano }}</span>
                    </span>
                  </ng-container>
                </div>
              </ng-container>

              <div class="ag-disp" *ngFor="let a of c.agendas; trackBy: trackAgenda">
                <div class="ag-cab">
                  <div class="med">
                    <b>{{ a.agenda.nmMedico || a.agenda.dsAgenda }}</b>
                    <span class="sub2" *ngIf="a.agenda.crmMedico">CRM {{ a.agenda.crmMedico }}</span>
                    <span class="sub2" *ngIf="a.agenda.dsEspecialidade">· {{ a.agenda.dsEspecialidade }}</span>
                  </div>
                  <div class="stats">
                    <span class="selo" *ngIf="a.retorno" [class.bad]="a.retorno.cheio" [class.ok]="!a.retorno.cheio">{{ a.retorno.texto }}</span>
                    <span class="selo cinza">{{ a.horarios.length }} vaga(s)</span>
                  </div>
                </div>

                <div class="badges">
                  <span class="selo info" *ngIf="a.agenda.telemedicinaPresencial" title="O médico atende por vídeo; o paciente precisa estar na unidade.">Médico online · paciente presencial</span>
                  <span class="selo warn" *ngIf="a.agenda.vigenciaExpirada">Vigência expirada</span>
                  <span class="selo cinza" *ngIf="rotuloIdade(a.agenda.idadeMin, a.agenda.idadeMax) as idade">{{ idade }}</span>
                  <button type="button" class="link" *ngIf="a.agenda.dsOrientacao" (click)="alternarDetalhe('o' + chaveCard(c.unidade, a.agenda))">Orientações</button>
                  <button type="button" class="link" *ngIf="preparo(a.agenda)" (click)="alternarDetalhe('p' + chaveCard(c.unidade, a.agenda))">Preparo</button>
                </div>
                <div class="detalhe" *ngIf="detalhes.has('o' + chaveCard(c.unidade, a.agenda))">{{ a.agenda.dsOrientacao }}</div>
                <div class="detalhe" *ngIf="detalhes.has('p' + chaveCard(c.unidade, a.agenda)) && preparo(a.agenda) as pr">
                  <ng-container *ngIf="pr.pac"><b>Orientação ao paciente</b><p>{{ pr.pac }}</p></ng-container>
                  <ng-container *ngIf="pr.usuario"><b>Orientação ao usuário</b><p>{{ pr.usuario }}</p></ng-container>
                </div>

                <div class="horas">
                  <button
                    type="button"
                    class="h-chip"
                    *ngFor="let h of horariosVisiveis(c.unidade, a); trackBy: trackVaga"
                    [class.res]="h.ieStatusAgenda === 'R'"
                    [title]="'Agendar ' + (h.dsAgenda || '') + ' (' + h.duracao + ' min)'"
                    (click)="clicarHorario(c.unidade, a.agenda, h)"
                  >{{ h.hrInicio }}</button>
                  <button
                    type="button"
                    class="link mais"
                    *ngIf="a.horarios.length > HORARIOS_INICIAIS"
                    (click)="alternarMais(c.unidade, a.agenda)"
                  >{{ expandidos.has(chaveCard(c.unidade, a.agenda)) ? 'Menos horários' : 'Mais horários (' + (a.horarios.length - HORARIOS_INICIAIS) + ')' }}</button>
                </div>
              </div>
            </div>

            <p class="total-dia" *ngIf="lista.length">{{ totalDoDia(lista) }} vaga(s) disponível(is) nesta data</p>
          </ng-container>
        </ng-container>
      </section>
    </div>
  </div>
</div>
